<template>
  <g>
    <path
      d="M22 4.00018C22 2.90018 21.1 2.00018 20 2.00018H4C2.9 2.00018 2.01 2.90018 2.01 4.00018L2 22.0002L6 18.0002H15V11.0002C15 10.4502 15.45 10.0002 16 10.0002H22V4.00018Z"
    />
    <path
      d="M21.69 16.0002H20.3L21.7 12.7002C21.84 12.3702 21.6 12.0002 21.24 12.0002H17.5C17.22 12.0002 17 12.2202 17 12.5002V17.5002C17 17.7802 17.22 18.0002 17.5 18.0002H19V21.9402C19 22.2002 19.36 22.2902 19.47 22.0502L22.13 16.7202C22.3 16.3902 22.06 16.0002 21.69 16.0002Z"
    />
  </g>
</template>
